import React, { FunctionComponent } from 'react';

/**
 * Thrash Icon
 */
const TrashIcon: FunctionComponent<React.PropsWithChildren<{ colour?: string }>> = ({
  colour = 'black'
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill={colour}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.66683 2L10.3335 2.66667H12.6668V4H3.3335V2.66667H5.66683L6.3335 2H9.66683ZM8.00016 8.39333L9.4135 6.98L10.3535 7.92L8.94016 9.33333L10.3535 10.7467L9.4135 11.6867L8.00016 10.2733L6.58683 11.6867L5.64683 10.7467L7.06016 9.33333L5.64016 7.92L6.58016 6.98L8.00016 8.39333ZM4.00016 12.6667C4.00016 13.4 4.60016 14 5.3335 14H10.6668C11.4002 14 12.0002 13.4 12.0002 12.6667V4.66667H4.00016V12.6667ZM10.6668 6H5.3335V12.6667H10.6668V6Z"
        fill={colour}
      />
    </svg>
  );
};

export default TrashIcon;
